import imagePreview from './image-preview.vue';
import eventBus from '../eventBus';
export default function install(Vue, options) {
  Vue.component('image-preview', imagePreview);
  Vue.directive('image-preview', {
    bind: function (el) {
      let handlerMap = new WeakMap(); // 用weakMap方式，元素消失后回调函数被回收，不会有内存泄漏
      let hanlder = e => {
        eventBus.$emit('image-preview:open', e.target.src);
      };
      handlerMap.set(el, hanlder);
      el.addEventListener('click', handlerMap.get(el));
    }, // 监听使用该指令的Dom元素。
  });
}
